import { Done, DoneAll } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import React from "react";
import { ReadStatus } from "../../../hooks/useMessageReadStatus";

interface MessageReadStatusProps {
  status?: ReadStatus;
  showTooltip?: boolean;
}

export const MessageReadStatus: React.FC<MessageReadStatusProps> = ({
  status,
  showTooltip = true,
}) => {
  // Skeleton para quando o status está carregando (apenas se realmente não tiver status)
  if (!status) {
    return (
      <Box sx={{ display: "inline-flex", alignItems: "center" }}>
        <Done sx={{ fontSize: "0.875rem", color: "#8696a0" }} />
      </Box>
    );
  }

  const getStatusIcon = () => {
    if (!status.isRead) {
      return <Done sx={{ fontSize: "0.875rem", color: "#8696a0" }} />;
    }
    return <DoneAll sx={{ fontSize: "0.875rem", color: "#53bdeb" }} />;
  };

  const getStatusText = () => {
    if (!status.isRead) {
      return "Enviado";
    }
    return `Lido ${
      status.readAt
        ? new Date(status.readAt).toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        : ""
    }`;
  };

  const statusComponent = (
    <Box sx={{ display: "inline-flex", alignItems: "center" }}>
      {getStatusIcon()}
    </Box>
  );

  if (showTooltip) {
    return (
      <Tooltip title={getStatusText()} placement="top" arrow>
        {statusComponent}
      </Tooltip>
    );
  }

  return statusComponent;
};
